import { render, staticRenderFns } from "./EtitorProducts.vue?vue&type=template&id=c90bb18c&scoped=true&"
import script from "./EtitorProducts.vue?vue&type=script&lang=js&"
export * from "./EtitorProducts.vue?vue&type=script&lang=js&"
import style0 from "./EtitorProducts.vue?vue&type=style&index=0&id=c90bb18c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90bb18c",
  null
  
)

export default component.exports